module.exports = __webpack_public_path__ + "static/media/vip4.51ba0f16.png";